import Card from 'components/card';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { getProductions } from 'interfaces/productions';
import { getProducts } from 'interfaces/products';
import { useDisclosure } from '@chakra-ui/hooks';
import ProductionPreviewModal from './components/ProductionPreview';
import LastProductions from 'views/admin/main/profile/overview/components/Project';
import EventCalendar from 'components/calendar/EventCalendar';
import InputField from 'components/fields/InputField';
import ActionButton from 'components/buttons/ActionButton';
import CreateButton from 'components/buttons/CreateButton';
import GoBack from 'components/actions/GoBack';
import SearchSelector from 'components/fields/SearchSelector';
import { MdFactory, MdCalendarMonth, MdSchedule } from 'react-icons/md';

const ViewProduction = () => {
    const navigate = useNavigate();
    const { isOpen, onOpen, onClose } = useDisclosure();

    const [product, setProduct] = useState<any>({
        date: new Date().toISOString().split('T')[0],
        quantity: 1,
        area: 'zone-a',
        lotNumber: '',
        comment: ' ',
        product: '',
        type: '',
    });
    const [products, setProducts] = useState<any[]>(null);
    const [productions, setProductions] = useState<any[]>(null);

    const handleChange = (e: any) => {
        if (!e.target) {
            setProduct({
                ...product,
                product: e,
            });
            return;
        }
        setProduct({
            ...product,
            [e.target.id]: e.target.value,
        });
    };

    const initProductions = async () => {
        const prods = await getProductions();
        if (!prods) {
            navigate('/auth/login');
            return;
        }
        setProductions(prods.data);
    };

    const initProducts = async () => {
        const prods = await getProducts(1, 10000);
        if (!prods) {
            navigate('/auth/login');
            return;
        }
        setProducts(prods.data);
    };

    const onProduction = async (prod: any) => {
        setProductions([prod, ...productions]);
        onClose();
    };

    const createProd = async () => {
        onOpen();
    };

    useEffect(() => {
        if (localStorage.getItem('token') === null) {
            navigate('/login');
        }
        initProductions();
        initProducts();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <>
            <ProductionPreviewModal
                isOpen={isOpen}
                onClose={onClose}
                product={product}
                productName={
                    products?.find((p) => p._id === product.product)?.name
                }
                onProduction={onProduction}
            />
            
            <div className="mt-2">
                <GoBack />
            </div>

            <div className="mt-2 grid grid-cols-12 gap-5">
                <div className={`col-span-12 mb-5 lg:col-span-6`}>
                    {/* Creation form */}
                    <Card extra={'w-full p-5 mb-4 border border-gray-200 dark:border-navy-700'}>
                        <div className="mb-4">
                            <h4 className="text-lg font-bold text-navy-700 dark:text-white">
                                Vos productions
                            </h4>
                            <p className="mt-1 text-sm text-gray-600 dark:text-gray-400">
                                Transformez et assemblez vos produits
                            </p>
                        </div>
                        
                        <div className="mt-5 grid grid-cols-12 gap-3">
                            <div className="col-span-12 md:col-span-6">
                                <SearchSelector
                                    displayKey="name"
                                    secondaryKey="ref"
                                    label="Produit*"
                                    options={products}
                                    onSelect={handleChange}
                                    inputSmall={true}
                                />
                            </div>
                            <div className="col-span-12 md:col-span-6">
                                <InputField
                                    label="Date de production*"
                                    placeholder="2021-09-01"
                                    value={product.date}
                                    onChange={handleChange}
                                    id="date"
                                    type="date"
                                    inputSmall={true}
                                />
                            </div>
                            <div className="col-span-6 md:col-span-4">
                                <InputField
                                    label="Quantité*"
                                    placeholder="1"
                                    id="quantity"
                                    type="number"
                                    value={product.quantity}
                                    onChange={handleChange}
                                    inputSmall={true}
                                />
                            </div>
                            <div className="col-span-6 md:col-span-4">
                                <label
                                    htmlFor={`zone`}
                                    className={`text-navy-700 dark:text-white text-xs font-bold`}
                                >
                                    Zone de stockage*
                                </label>
                                <div className="flex w-full h-[35px] rounded-xl border border-gray-200 px-2.5 py-auto text-sm text-gray-600 outline-none focus-within:border-toola-500 dark:!border-white/10 dark:!bg-navy-800 dark:text-white">
                                    <select
                                        id="area"
                                        className="w-full bg-transparent outline-none"
                                        onChange={handleChange}
                                    >
                                        {[
                                            { v: 'zone-a', l: 'Zone A' },
                                            { v: 'zone-b', l: 'Zone B' },
                                            { v: 'zone-c', l: 'Zone C' },
                                        ].map((item, index) => (
                                            <option key={index} value={item.v}>
                                                {item.l}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                            </div>
                            <div className="col-span-12 md:col-span-4">
                                <InputField
                                    label="Numéro de lot*"
                                    placeholder="FO-0025"
                                    id="lotNumber"
                                    type="text"
                                    onChange={(e: any) => handleChange(e)}
                                    inputSmall={true}
                                />
                            </div>
                            <div className="col-span-12">
                                <InputField
                                    label="Commentaire"
                                    placeholder={
                                        'Production de Lucas à ' +
                                        new Date()
                                            .toISOString()
                                            .split('T')[1]
                                            .split('.')[0]
                                    }
                                    id="comment"
                                    type="text"
                                    onChange={handleChange}
                                    inputSmall={true}
                                />
                            </div>
                            <div className="col-span-12 mt-2">
                                <ActionButton
                                    value="Prévisualiser la production"
                                    extra={`w-full text-sm h-[40px] ${
                                        product.product !== ''
                                            ? 'bg-toola-500 hover:bg-toola-600 active:bg-toola-700'
                                            : 'bg-gray-300 cursor-not-allowed hover:bg-gray-300'
                                    }`}
                                    onClick={() => product.product !== '' && createProd()}
                                />
                            </div>
                        </div>
                    </Card>

                    {/* Scheduled productions card */}
                    {productions &&
                        productions.filter((p) => p.status === 'scheduled')
                            .length > 0 && (
                            <Card extra="w-full mb-4 overflow-hidden border border-orange-200 dark:border-orange-800">
                                <div className="bg-gradient-to-r from-orange-400 to-orange-500 p-4">
                                    <div className="flex items-center justify-between">
                                        <div className="flex items-center gap-3">
                                            <div className="flex h-10 w-10 items-center justify-center rounded-lg bg-white/30">
                                                <MdSchedule className="h-5 w-5 text-white" />
                                            </div>
                                            <div>
                                                <p className="text-base font-bold text-white">
                                                    {productions.filter((p) => p.status === 'scheduled').length} production{productions.filter((p) => p.status === 'scheduled').length > 1 ? 's' : ''} planifiée{productions.filter((p) => p.status === 'scheduled').length > 1 ? 's' : ''}
                                                </p>
                                                <p className="text-sm text-white/90">
                                                    En attente de réalisation
                                                </p>
                                            </div>
                                        </div>
                                        <CreateButton
                                            value="Visualiser"
                                            extra="bg-white hover:bg-white/90 text-orange-600 h-10 text-sm px-4"
                                            onClick={() => navigate('/planned-production')}
                                        />
                                    </div>
                                </div>
                            </Card>
                        )}
                    
                    {/* Calendrier */}
                    <Card extra="w-full p-4 h-full">
                        <div className="mb-3 flex items-center gap-3">
                            <div className="flex h-8 w-8 items-center justify-center rounded-lg bg-purple-50 dark:bg-purple-900/30">
                                <MdCalendarMonth className="h-4 w-4 text-purple-500" />
                            </div>
                            <h4 className="text-base font-bold text-navy-700 dark:text-white">
                                Calendrier de production
                            </h4>
                        </div>
                        <div style={{ height: '500px' }}>
                            {!isOpen && productions && (
                                <EventCalendar
                                    initialDate={new Date().toISOString()}
                                    calendarData={
                                        productions.map((prod) => {
                                            return {
                                                title: `${prod.productName} x ${prod.quantity}`,
                                                borderColor: 'transparent',
                                                start: prod.date
                                                    ? prod.date.split('T')[0]
                                                    : '',
                                                end: prod.date
                                                    ? prod.date.split('T')[0]
                                                    : '',
                                                backgroundColor:
                                                    prod.status === 'scheduled'
                                                        ? '#FF973B'
                                                        : '#0260CB',
                                                className: 'warning',
                                                extra: 'text-xs',
                                            };
                                        })
                                    }
                                />
                            )}
                        </div>
                    </Card>
                </div>
                
                <div className={`col-span-12 lg:col-span-6`}>
                    {/* Preparation card */}
                    <Card extra={'w-full p-5 mb-4 border border-gray-200 dark:border-navy-700'}>
                        <div className="flex items-center justify-between">
                            <div className="flex items-center gap-3">
                                <div className="flex h-10 w-10 items-center justify-center rounded-lg bg-green-50 dark:bg-green-900/30">
                                    <MdFactory className="h-5 w-5 text-green-500" />
                                </div>
                                <div>
                                    <h4 className="text-base font-bold text-navy-700 dark:text-white">
                                        Préparation des productions
                                    </h4>
                                    <p className="text-sm text-gray-600 dark:text-gray-400">
                                        Préparez vos productions à l'avance
                                    </p>
                                </div>
                            </div>
                            <CreateButton
                                value="Accéder"
                                extra="bg-toola-500 hover:bg-toola-600 active:bg-toola-700 h-10 text-sm px-4"
                                onClick={() => navigate('/stock/prepare-production')}
                            />
                        </div>
                    </Card>
                    
                    {/* Latest productions */}
                    <div className="col-span-12">
                        <LastProductions productions={productions} />
                    </div>
                </div>
            </div>
        </>
    );
};

export default ViewProduction;
